import { Suspense } from 'react';

import { SettingsNav } from './settings-nav';
import { ViewContent, ViewHeader } from './view-layout';

interface SettingsLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  fallback: React.ReactNode;
  title: string;
}

export function SettingsLayout({
  children,
  fallback,
  title,
  header,
}: SettingsLayoutProps) {
  return (
    <>
      <ViewHeader title={title}>{header}</ViewHeader>
      <ViewContent>
        <div className="flex h-full">
          <SettingsNav />
          <div className="flex-1 px-6 py-3">
            <Suspense fallback={fallback}>{children}</Suspense>
          </div>
        </div>
      </ViewContent>
    </>
  );
}
